// ABOUTME: Checkbox with label component for consistent alignment
// ABOUTME: Wraps CCheckbox with CLabel using flex alignment pattern

import * as React from "react"
import { CCheckbox, type CCheckboxProps } from "./CCheckbox"
import { CLabel } from "./CLabel"
import { cn } from "@shared/lib/utils"

export interface CCheckboxGroupProps extends CCheckboxProps {
  label: React.ReactNode
  labelClassName?: string
  containerClassName?: string
}

export const CCheckboxGroup = React.forwardRef<HTMLInputElement, CCheckboxGroupProps>(
  ({ label, labelClassName, containerClassName, className, id, ...checkboxProps }, ref) => {
    return (
      <CLabel
        htmlFor={id}
        className={cn("flex items-center cursor-pointer", containerClassName)}
      >
        <CCheckbox
          ref={ref}
          id={id}
          className={cn("disabled:opacity-50 disabled:cursor-not-allowed", className)}
          {...checkboxProps}
        />
        <span className={cn("ml-3", labelClassName)}>{label}</span>
      </CLabel>
    )
  },
)

CCheckboxGroup.displayName = "CCheckboxGroup"
